var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillOpacity":".6","d":"M10 9.594L.39-.002 0 .402l9.611 9.596z","key":0}),React.createElement("path",{"fillOpacity":".6","d":"M0 9.594L9.61-.002l.39.404L.389 9.998z","key":1})]);
}

Close.defaultProps = {"viewBox":"0 0 10 10","fill":"currentColor"};

module.exports = Close;

Close.default = Close;
